import axios from 'axios';

export const axiosPublic = axios.create({
  baseURL: "https://api.nextniro.com/api",
  headers: {
    //'Authorization': `Bearer ${token}`,
    'Authorization' : `Bearer ${localStorage.getItem("token")}`,
    'Content-Type': 'application/json',
}
});